import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_OPTION_PRICE_PAGINATION } from "../Schema/OptionPrice";

const useGetOptionPricePagination = ({ classId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { refetch } = useQuery(GET_OPTION_PRICE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
      classId: classId,
    },
    onCompleted: ({ getOptionPricePagination }) => {
      // console.log("getOptionPricePagination :", getOptionPricePagination);
      setTableData(getOptionPricePagination?.data);
      setPaginationData(getOptionPricePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.error("Error fetching content:", err.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [page, limit, classId]);

  const handleLimit = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const handleSearch = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    setLoading,
    tableData,
    paginationData,
    handleLimit,
    handleSearch,
  };
};

export default useGetOptionPricePagination;
